import LyRadio from './src/index.vue'

LyRadio.install = function (Vue) {
    Vue.component(LyRadio.name, LyRadio)
}

export default LyRadio



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/radio/index.js
// module id = null
// module chunks = 